function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { AdBreakType } from '../../addons/adverts/common';
import { CoreVideoInternal } from '../../core-video-internal';
import { CvsdkError, ErrorSeverity } from '../../error';
import { sdkLogger } from '../../logger';
import { Observable } from '../../utils/observables/observable';
import { checkIsManifestLinearType } from '../../utils/playback-type';
import { SimpleTimer } from '../../utils/simple-timer';
import { cloneAdBreak, cloneAdBreakArray } from '../../utils/ad-break-utils';
/** Enforce a minimum start position when preroll is present. Some devices have issues starting exactly at 0. */ /** Always force prerolls to be watched, even if bookmarking is enabled. */ /** Some devices are unable to start playback close to an ad break */ var AdBreakMatchTolerance = 1;
// sometimes there's an automatic seek when going into an adBreak. if this happens, we don't want to skip the adBreak
var SkipAdTolerance = 0.5;
// Default ad break end tolerance
var AdBreakEndTolerance = 0.5;
// Allow inputs after X seconds in case we don't receive a break started event
export var InputBlockingTimeLimit = 3000;
// Given a start position, this is how close to the ad break we consider "starting playback at an ad break"
var AdBreakStartThresholdSeconds = 12;
export var AdPolicyManager = /*#__PURE__*/ function() {
    "use strict";
    function AdPolicyManager(adPolicyConfig) {
        var _this = this;
        _class_call_check(this, AdPolicyManager);
        var _CoreVideoInternal_config_default_addons_adInsertion, _CoreVideoInternal_config_default_addons, _CoreVideoInternal_config_default, _CoreVideoInternal_config;
        _define_property(this, "seekObservable", new Observable());
        _define_property(this, "catchupSeekObservable", new Observable());
        _define_property(this, "adBreaks", null);
        _define_property(this, "postAdSeekPosition", null);
        _define_property(this, "postAdSeekDeltaToLiveEdge", null);
        _define_property(this, "watchedAds", []);
        _define_property(this, "adPolicy", void 0);
        _define_property(this, "inputBlockingMaxTimeout", new SimpleTimer());
        _define_property(this, "isSeekingToAdBreak", false);
        _define_property(this, "currentPlaybackTimeline", null);
        _define_property(this, "adBreakEndTolerance", void 0);
        _define_property(this, "adPolicyConfig", void 0);
        _define_property(this, "shouldPlayAdBreak", function(adBreak, position, isResumingFromBookmark) {
            adBreak = cloneAdBreak(adBreak);
            if (_this.watchedAds.includes(adBreak.id)) {
                // Ensure the ad break has the proper watched status based on the internal record.
                adBreak.watched = true;
            }
            return _this.adPolicy.shouldPlayAdBreak(adBreak, position, isResumingFromBookmark);
        });
        var propositionExtensions = CoreVideoInternal.getPropositionExtensions();
        this.adPolicyConfig = _object_spread({}, (_CoreVideoInternal_config = CoreVideoInternal.config) === null || _CoreVideoInternal_config === void 0 ? void 0 : (_CoreVideoInternal_config_default = _CoreVideoInternal_config.default) === null || _CoreVideoInternal_config_default === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons = _CoreVideoInternal_config_default.addons) === null || _CoreVideoInternal_config_default_addons === void 0 ? void 0 : (_CoreVideoInternal_config_default_addons_adInsertion = _CoreVideoInternal_config_default_addons.adInsertion) === null || _CoreVideoInternal_config_default_addons_adInsertion === void 0 ? void 0 : _CoreVideoInternal_config_default_addons_adInsertion.adPolicyConfig, adPolicyConfig);
        var AdPolicyClass = propositionExtensions.adPolicy;
        if (AdPolicyClass) {
            this.adPolicy = new AdPolicyClass();
        } else {
            var error = CvsdkError.from({
                severity: ErrorSeverity.Fatal,
                message: "No AdPolicyManager support found for ".concat(adPolicyConfig.proposition),
                code: 'AD_POLICY_MANAGER.NO_PROPOSITION_SUPPORT'
            });
            throw error;
        }
        this.adBreakEndTolerance = typeof adPolicyConfig.adBreakEndTolerance === 'number' ? adPolicyConfig.adBreakEndTolerance : AdBreakEndTolerance;
    }
    _create_class(AdPolicyManager, [
        {
            key: "initialise",
            value: function initialise(onPlaybackTimelineUpdated) {
                var _this = this;
                onPlaybackTimelineUpdated(function(playbackTimeline) {
                    _this.currentPlaybackTimeline = playbackTimeline;
                });
            }
        },
        {
            key: "notifyPositionChanged",
            value: function notifyPositionChanged(currentTimeSeconds) {
                this.adPolicy.notifyPositionChanged(currentTimeSeconds);
            }
        },
        {
            key: "setAdBreaksData",
            value: function setAdBreaksData(adBreaks) {
                var _this = this;
                var adBreakIsPlayable = function(adBreak) {
                    return adBreak.ads.length > 0;
                };
                this.adBreaks = cloneAdBreakArray(adBreaks).// Ad Policy manager assumes every ad stored in its internal list
                // is _playable_, so omit empty ad breaks
                filter(adBreakIsPlayable).map(function(adBreak) {
                    //Sync watched statuses
                    if (_this.watchedAds.includes(adBreak.id)) {
                        adBreak.watched = true;
                    } else if (adBreak.watched) {
                        _this.watchedAds.push(adBreak.id);
                    }
                    return adBreak;
                });
                this.adPolicy.notifyAdBreakDataChanged(this.adBreaks);
            }
        },
        {
            key: "getManagedAdBreakById",
            value: /**
     * Returns a direct reference to the specified adBreak managed by this ad policy manager instance. Will not return stale ads that have been since replaced by setAdBreaksData().
     * @param id The id of the managed ad break to retrieve.
     * @returns The resulting ad break, or null if it cannot be found.
     */ function getManagedAdBreakById(id) {
                var _this_adBreaks;
                var _this_adBreaks_find;
                return (_this_adBreaks_find = (_this_adBreaks = this.adBreaks) === null || _this_adBreaks === void 0 ? void 0 : _this_adBreaks.find(function(adBreak) {
                    return adBreak.id === id;
                })) !== null && _this_adBreaks_find !== void 0 ? _this_adBreaks_find : null;
            }
        },
        {
            key: "getAdBreakWatchedStatus",
            value: /**
     * Helper to return the watched status of the specified ad break. Searches through both the currently assigned adBreaks as well as any historically watched breaks.
     * @param id The id of ad break to check watched status for.
     * @returns True when there is a record that the adBreak has been watched at least once.
     */ function getAdBreakWatchedStatus(id) {
                var _this_getManagedAdBreakById;
                var _this_getManagedAdBreakById_watched;
                return (_this_getManagedAdBreakById_watched = (_this_getManagedAdBreakById = this.getManagedAdBreakById(id)) === null || _this_getManagedAdBreakById === void 0 ? void 0 : _this_getManagedAdBreakById.watched) !== null && _this_getManagedAdBreakById_watched !== void 0 ? _this_getManagedAdBreakById_watched : this.watchedAds.includes(id);
            }
        },
        {
            key: "getAdBreaks",
            value: /**
     * Returns a clone of the ad breaks that are being actively managed by this ad policy manager instance. Will not return stale ads that have been since replaced by setAdBreaksData().
     * @returns
     */ function getAdBreaks() {
                return cloneAdBreakArray(this.adBreaks || []);
            }
        },
        {
            key: "onShouldSeek",
            value: function onShouldSeek(callback) {
                this.seekObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onCatchupSeek",
            value: function onCatchupSeek(callback) {
                this.catchupSeekObservable.registerObserver(callback, this);
            }
        },
        {
            key: "manageSeek",
            value: function manageSeek(currentPosition, seekToPosition) {
                var clearPostAdSeekPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                if (this.adPolicyConfig.isSeekManagementRequired && this.adBreaks) {
                    if (this.shouldEnforceAdRules(seekToPosition)) {
                        return this.enforceUnwatchedBreaks(currentPosition, seekToPosition, clearPostAdSeekPosition);
                    }
                    return this.skipToAdBreakEnd(seekToPosition);
                }
                return seekToPosition;
            }
        },
        {
            key: "seekEnded",
            value: function seekEnded() {
                var _this = this;
                this.adPolicy.notifySeekEnded();
                if (this.isSeekingToAdBreak) {
                    // Allow inputs after X seconds in case we don't receive a break started event
                    this.inputBlockingMaxTimeout.start({
                        timeMs: InputBlockingTimeLimit,
                        callback: function() {
                            _this.isSeekingToAdBreak = false;
                        }
                    });
                }
            }
        },
        {
            key: "seekStarted",
            value: function seekStarted() {
                this.adPolicy.notifySeekStarted();
            }
        },
        {
            key: "isPlayingAdBreakPositionSSAI",
            value: function isPlayingAdBreakPositionSSAI(position) {
                if (this.adPolicyConfig.isSeekManagementRequired) {
                    var adBreakPlaying = this.getAdBreakPlayingByPositionSSAI(position);
                    if (adBreakPlaying) {
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "manageStartPosition",
            value: function manageStartPosition(startPosition) {
                var _this = this;
                var _this_adBreaks;
                var hasPreroll = (_this_adBreaks = this.adBreaks) === null || _this_adBreaks === void 0 ? void 0 : _this_adBreaks.some(function(adBreak) {
                    return adBreak.type === AdBreakType.Preroll;
                });
                // This is a workaround for an issue on samsung TVs.
                // A ticket has been created for a further investigation.
                // https://github.com/sky-uk/core-video-team/issues/6025
                if (!startPosition && this.adPolicyConfig.minimumPrerollStartPosition) {
                    return hasPreroll ? this.adPolicyConfig.minimumPrerollStartPosition : startPosition;
                }
                // If start position is 0 or undefined we don't need to modify
                if (!startPosition || !this.adBreaks) {
                    return startPosition;
                }
                this.validateStartPosition(startPosition);
                var midrollAtStart = this.adBreaks.find(function(adBreak) {
                    return adBreak.type === AdBreakType.Midroll && typeof adBreak.position === 'number' && adBreak.position - startPosition >= 0 && adBreak.position - startPosition < AdBreakStartThresholdSeconds;
                });
                if (hasPreroll && this.adPolicyConfig.alwaysForcePrerolls) {
                    // Safari has an issue where it will show the first few frames of
                    // the preroll before reaching the start position.
                    // This workaround will play the preroll and skip the midroll if on safari
                    return this.forceWatchPreroll(startPosition, midrollAtStart);
                }
                if (midrollAtStart) {
                    return this.adPolicyConfig.canStartNearMidroll ? startPosition : midrollAtStart.position - AdBreakStartThresholdSeconds;
                }
                var midrollAtEnd = this.adBreaks.find(function(adBreak) {
                    return adBreak.type === AdBreakType.Midroll && typeof adBreak.position === 'number' && adBreak.expectedDuration && adBreak.position + adBreak.expectedDuration <= startPosition && adBreak.position + adBreak.expectedDuration + _this.adBreakEndTolerance > startPosition;
                });
                if (midrollAtEnd) {
                    return midrollAtEnd.position + midrollAtEnd.expectedDuration + this.adBreakEndTolerance;
                }
                return startPosition;
            }
        },
        {
            key: "manageAdBreakStarted",
            value: function manageAdBreakStarted(adBreak) {
                this.isSeekingToAdBreak = false;
                this.inputBlockingMaxTimeout.stop();
                if (this.adPolicyConfig.isWatchedAdsManagementRequired && this.shouldEnforceAdRules() && this.getAdBreakWatchedStatus(adBreak.id)) {
                    this.skipAdBreak(adBreak);
                    return null;
                }
                if (this.adPolicyConfig.allowAdSkipCatchup && this.adPolicy.canAdSkipCatchup() && CoreVideoInternal.playerCapabilities.supportsAdSkipCatchup) {
                    var adSkipPosition = this.skipAds(adBreak);
                    if (adSkipPosition && adSkipPosition >= adBreak.position + adBreak.expectedDuration) {
                        // In case an entire ad break is skipped
                        return null;
                    }
                }
                this.adPolicy.notifyAdBreakStarted(adBreak);
                return adBreak;
            }
        },
        {
            key: "manageAdBreakFinished",
            value: function manageAdBreakFinished(adBreak) {
                var _this_currentPlaybackTimeline_seekableRange, _this_currentPlaybackTimeline;
                var localAdBreak = this.getManagedAdBreakById(adBreak.id);
                var hasWatchHistory = this.watchedAds.includes(adBreak.id);
                var wasWatched = (localAdBreak === null || localAdBreak === void 0 ? void 0 : localAdBreak.watched) || hasWatchHistory;
                if (this.adPolicyConfig.isWatchedAdsManagementRequired && this.shouldEnforceAdRules() && wasWatched) {
                    return null;
                }
                // Update watched statuses
                if (localAdBreak) {
                    localAdBreak.watched = true;
                }
                if (!hasWatchHistory) {
                    this.watchedAds.push(adBreak.id);
                }
                if (typeof this.postAdSeekPosition === 'number') {
                    this.notifySeekSafelyInNextTick(this.postAdSeekPosition);
                } else if (typeof this.postAdSeekDeltaToLiveEdge === 'number' && ((_this_currentPlaybackTimeline = this.currentPlaybackTimeline) === null || _this_currentPlaybackTimeline === void 0 ? void 0 : (_this_currentPlaybackTimeline_seekableRange = _this_currentPlaybackTimeline.seekableRange) === null || _this_currentPlaybackTimeline_seekableRange === void 0 ? void 0 : _this_currentPlaybackTimeline_seekableRange.end)) {
                    var _this_currentPlaybackTimeline_seekableRange1, _this_currentPlaybackTimeline1;
                    var postAdSeekPosition = ((_this_currentPlaybackTimeline1 = this.currentPlaybackTimeline) === null || _this_currentPlaybackTimeline1 === void 0 ? void 0 : (_this_currentPlaybackTimeline_seekableRange1 = _this_currentPlaybackTimeline1.seekableRange) === null || _this_currentPlaybackTimeline_seekableRange1 === void 0 ? void 0 : _this_currentPlaybackTimeline_seekableRange1.end) - this.postAdSeekDeltaToLiveEdge;
                    this.notifySeekSafelyInNextTick(postAdSeekPosition);
                }
                this.adPolicy.notifyAdBreakEnded(adBreak);
                if (!wasWatched) {
                    // Only notify of change if the watched field was updated
                    this.adPolicy.notifyAdBreakDataChanged(this.adBreaks);
                }
                return adBreak;
            }
        },
        {
            key: "manageAdStarted",
            value: function manageAdStarted(ad) {
                if (this.adPolicyConfig.isWatchedAdsManagementRequired && this.shouldEnforceAdRules() && this.getAdBreakWatchedStatus(ad.adBreakId)) {
                    return null;
                }
                return ad;
            }
        },
        {
            key: "manageAdFinished",
            value: function manageAdFinished(ad) {
                if (this.adPolicyConfig.isWatchedAdsManagementRequired && this.shouldEnforceAdRules() && this.getAdBreakWatchedStatus(ad.adBreakId)) {
                    return null;
                }
                return ad;
            }
        },
        {
            key: "getAdBreaksToPlayOnSeekingForward",
            value: function getAdBreaksToPlayOnSeekingForward(skipped, currentPosition, seekToPosition) {
                var adBreak;
                if (skipped) {
                    adBreak = this.adPolicy.getAdBreakToPlayBySkippedAdBreaks(skipped);
                } else if (currentPosition != null && seekToPosition != null) {
                    adBreak = this.getAdBreakToPlayByPosition(this.adBreaks, currentPosition, seekToPosition);
                } else {
                    sdkLogger.warn('When seeking should provide skipped ad breaks, or, the from and to seek position in order to get the adBreaks to play');
                }
                if (adBreak) {
                    return [
                        adBreak
                    ];
                }
            }
        },
        {
            key: "disable",
            value: function disable() {
                sdkLogger.warn('Ad Policy Manager - Disabling ad policy manager');
                this.clearAdBreaks();
                this.disableAdPolicyLogic();
                this.seekObservable.unregisterObservers(this);
                this.catchupSeekObservable.unregisterObservers(this);
                this.inputBlockingMaxTimeout.destroy();
            }
        },
        {
            key: "clearAdBreaks",
            value: function clearAdBreaks() {
                this.adBreaks = null;
            }
        },
        {
            key: "disableAdPolicyLogic",
            value: function disableAdPolicyLogic() {
                this.adPolicyConfig.isWatchedAdsManagementRequired = false;
                this.adPolicyConfig.isSeekManagementRequired = false;
            }
        },
        {
            key: "doesAdBreakStartBefore",
            value: function doesAdBreakStartBefore(adBreak, position) {
                if (typeof adBreak.position === 'number') {
                    return adBreak.position - SkipAdTolerance <= position;
                }
                return adBreak.position === 'start' && position > 0;
            }
        },
        {
            key: "findAdBreakForPosition",
            value: function findAdBreakForPosition(position, shouldAddEndTolerance) {
                var _this = this;
                return this.adBreaks.find(function(adBreak) {
                    if (typeof adBreak.position === 'number') {
                        var endTolerance = shouldAddEndTolerance ? _this.adBreakEndTolerance : 0;
                        var startsInPast = _this.doesAdBreakStartBefore(adBreak, position);
                        var endsInFuture = adBreak.position + adBreak.expectedDuration + endTolerance > position;
                        return startsInPast && endsInFuture;
                    }
                    return adBreak.position === 'start' && position === 0;
                });
            }
        },
        {
            key: "getAdBreakToPlayByPosition",
            value: function getAdBreakToPlayByPosition(adBreaks, currentPosition, seekToPosition) {
                var _this = this;
                if (!this.adPolicy.canPlayAdBreak() || adBreaks === null) {
                    return null;
                }
                var skippedAdBreaks = adBreaks.filter(function(adBreak) {
                    if (typeof adBreak.position === 'string') {
                        // if its string then it will be preroll or post role. N/A for now
                        return false;
                    }
                    var isFutureAdBreak = adBreak.position >= currentPosition;
                    var wouldBeSkippedOver = _this.doesAdBreakStartBefore(adBreak, seekToPosition);
                    return isFutureAdBreak && wouldBeSkippedOver;
                });
                return this.adPolicy.getAdBreakToPlayBySkippedAdBreaks(skippedAdBreaks);
            }
        },
        {
            key: "getAdBreakPlayingByPositionSSAI",
            value: function getAdBreakPlayingByPositionSSAI(currentPosition) {
                if (this.adBreaks === null) {
                    return null;
                }
                var skippedAdBreaks = this.adBreaks.filter(function(adBreak) {
                    if (typeof adBreak.position === 'string') {
                        // if its string then it will be preroll or postroll. N/A for now
                        return false;
                    }
                    return adBreak.position <= currentPosition && adBreak.position + adBreak.expectedDuration > currentPosition;
                });
                return this.adPolicy.getAdBreakToPlayBySkippedAdBreaks(skippedAdBreaks);
            }
        },
        {
            key: "forceWatchPreroll",
            value: function forceWatchPreroll(startPosition, midroll) {
                if (midroll && typeof midroll.position === 'number' && typeof midroll.expectedDuration === 'number') {
                    this.postAdSeekPosition = midroll.position + midroll.expectedDuration + this.adBreakEndTolerance;
                } else {
                    this.postAdSeekPosition = startPosition;
                }
                return 0;
            }
        },
        {
            key: "manageSeekCloseToBreak",
            value: function manageSeekCloseToBreak(position) {
                var nearBreakPosition = 0;
                for(var i = 0; i < this.adBreaks.length; i++){
                    var adBreak = this.adBreaks[i];
                    if (typeof adBreak.position === 'string') {
                        continue;
                    }
                    if (adBreak.position >= position && adBreak.position - position < AdBreakStartThresholdSeconds) {
                        nearBreakPosition = adBreak.position;
                        break;
                    }
                }
                if (nearBreakPosition) {
                    var positionWithOffset = Math.max(nearBreakPosition - AdBreakStartThresholdSeconds, 0);
                    sdkLogger.info("Fixing post ad break seek position (from ".concat(position, " to ").concat(positionWithOffset, ") to have a safe distance from next break"));
                    return positionWithOffset;
                } else if (this.findAdBreakForPosition(position)) {
                    return null;
                } else {
                    return position;
                }
            }
        },
        {
            key: "validateStartPosition",
            value: function validateStartPosition(startPosition) {
                var reverseAdBreaks = this.adBreaks ? _to_consumable_array(this.adBreaks).reverse() : [];
                var adBreakBeforeStart = reverseAdBreaks.find(function(x) {
                    return +x.position <= startPosition + AdBreakMatchTolerance;
                });
                if (adBreakBeforeStart && typeof adBreakBeforeStart.position === 'number' && startPosition > adBreakBeforeStart.position && adBreakBeforeStart.position + adBreakBeforeStart.expectedDuration > startPosition) {
                    throw new Error('Not supported: bookmark is set to position within ad break');
                }
            }
        },
        {
            key: "skipAdBreak",
            value: function skipAdBreak(adBreak) {
                if (adBreak.position !== 'end' && adBreak.expectedDuration) {
                    var adStartPosition = adBreak.position === 'start' ? 0 : adBreak.position;
                    this.seekObservable.reset();
                    this.seekObservable.notifyObservers(adStartPosition + adBreak.expectedDuration + this.adBreakEndTolerance);
                }
            }
        },
        {
            key: "skipAds",
            value: function skipAds(adBreak) {
                if (checkIsManifestLinearType(this.adPolicyConfig.sessionItem.type) && typeof adBreak.position === 'number' && adBreak.expectedDuration) {
                    var _ref = CoreVideoInternal.playerCapabilities.adSkipCatchup || {}, minDrift = _ref.minDrift, maxDrift = _ref.maxDrift, minSeek = _ref.minSeek;
                    minDrift || (minDrift = 20);
                    maxDrift || (maxDrift = 240);
                    minSeek || (minSeek = 10);
                    var adStartPosition = adBreak.position;
                    var distanceToLiveEdge = this.currentPlaybackTimeline.seekableRange.end - adStartPosition;
                    if (distanceToLiveEdge > minDrift && distanceToLiveEdge < maxDrift) {
                        var postAdSkipPosition = adStartPosition;
                        var adsSkipped = 0;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = adBreak.ads[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var ad = _step.value;
                                if (postAdSkipPosition + ad.expectedDuration < this.currentPlaybackTimeline.seekableRange.end) {
                                    postAdSkipPosition += ad.expectedDuration;
                                    adsSkipped++;
                                    continue;
                                }
                                break;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (postAdSkipPosition - adStartPosition < minSeek) {
                            return;
                        }
                        if (postAdSkipPosition + this.adBreakEndTolerance > adStartPosition + adBreak.expectedDuration) {
                            postAdSkipPosition += this.adBreakEndTolerance;
                        }
                        this.seekObservable.reset();
                        this.seekObservable.notifyObservers(postAdSkipPosition);
                        this.catchupSeekObservable.notifyObservers({
                            adsSkipped: adsSkipped,
                            index: 0,
                            // Phase I - start from the first ad
                            duration: postAdSkipPosition - adStartPosition
                        });
                        return postAdSkipPosition;
                    }
                }
            }
        },
        {
            key: "notifySeekSafelyInNextTick",
            value: function notifySeekSafelyInNextTick(postAdSeekPosition) {
                var _this = this;
                Promise.resolve().then(function() {
                    _this.seekObservable.reset();
                    _this.seekObservable.notifyObservers(postAdSeekPosition);
                    _this.postAdSeekPosition = null;
                    _this.postAdSeekDeltaToLiveEdge = null;
                });
            }
        },
        {
            key: "enforceUnwatchedBreaks",
            value: function enforceUnwatchedBreaks(currentPosition, seekToPosition, clearPostAdSeekPosition) {
                var shouldBlockSeekDuringAd = !this.adPolicyConfig.allowSeekingDuringAdBreaks && this.isPlayingAdBreakPositionSSAI(currentPosition);
                if (this.isSeekingToAdBreak || shouldBlockSeekDuringAd) {
                    return null;
                }
                if (seekToPosition <= 0) {
                    return this.adPolicy.getMinimumSeekablePositionAfterPreroll(this.adBreaks);
                }
                if (clearPostAdSeekPosition) {
                    this.postAdSeekPosition = null;
                    this.postAdSeekDeltaToLiveEdge = null;
                }
                var adBreakToPlay = this.getAdBreakToPlayByPosition(this.adBreaks, currentPosition, seekToPosition);
                if (adBreakToPlay) {
                    var _this_currentPlaybackTimeline_seekableRange, _this_currentPlaybackTimeline;
                    this.isSeekingToAdBreak = true;
                    this.inputBlockingMaxTimeout.stop();
                    if (!checkIsManifestLinearType(this.adPolicyConfig.sessionItem.type)) {
                        this.postAdSeekPosition = this.manageSeekCloseToBreak(seekToPosition);
                    } else if ((_this_currentPlaybackTimeline = this.currentPlaybackTimeline) === null || _this_currentPlaybackTimeline === void 0 ? void 0 : (_this_currentPlaybackTimeline_seekableRange = _this_currentPlaybackTimeline.seekableRange) === null || _this_currentPlaybackTimeline_seekableRange === void 0 ? void 0 : _this_currentPlaybackTimeline_seekableRange.end) {
                        var _this_currentPlaybackTimeline_seekableRange1, _this_currentPlaybackTimeline1;
                        this.postAdSeekDeltaToLiveEdge = Math.max(((_this_currentPlaybackTimeline1 = this.currentPlaybackTimeline) === null || _this_currentPlaybackTimeline1 === void 0 ? void 0 : (_this_currentPlaybackTimeline_seekableRange1 = _this_currentPlaybackTimeline1.seekableRange) === null || _this_currentPlaybackTimeline_seekableRange1 === void 0 ? void 0 : _this_currentPlaybackTimeline_seekableRange1.end) - seekToPosition, 0);
                    }
                    return adBreakToPlay.position;
                } else {
                    var currentAdBreak = this.findAdBreakForPosition(seekToPosition, true);
                    if (typeof (currentAdBreak === null || currentAdBreak === void 0 ? void 0 : currentAdBreak.position) === 'number') {
                        return currentAdBreak.position + currentAdBreak.expectedDuration + this.adBreakEndTolerance;
                    }
                    return this.skipToAdBreakEnd(seekToPosition);
                }
            }
        },
        {
            key: "skipToAdBreakEnd",
            value: function skipToAdBreakEnd(seekToPosition) {
                var currentAdBreak = this.findAdBreakForPosition(seekToPosition);
                if (currentAdBreak && typeof (currentAdBreak === null || currentAdBreak === void 0 ? void 0 : currentAdBreak.position) === 'number') {
                    var positionAtEndOfAd = currentAdBreak.position + currentAdBreak.expectedDuration + this.adBreakEndTolerance;
                    if (this.currentPlaybackTimeline.seekableRange.end < positionAtEndOfAd || seekToPosition - SkipAdTolerance < currentAdBreak.position) {
                        return currentAdBreak.position;
                    }
                    return positionAtEndOfAd;
                }
                return seekToPosition;
            }
        },
        {
            key: "shouldEnforceAdRules",
            value: /**
     * See https://github.com/NBCUDTC/core-video-team/wiki/Peacock-Scrubbing-Requirements
     *
     * For VOD we will always enforce ad rules
     * For Live at live edge we will always enforce ad rules
     * For Live in DVR mode (behind live edge) the following applies:
     *     - Ad rules around seeking over ad breaks are not enforced (the user will not be forced to watch an ad break after seeking)
     *     - Ad rules inside ad breaks are enforced EG once the timeline reaches a ad break the user is forced to watch that ad break,
     *           player controls are disabled and only pause play will be allowed (similar to live mode experience)
     *
     * @param seekToPosition
     * @returns
     */ function shouldEnforceAdRules(seekToPosition) {
                var _this_currentPlaybackTimeline_seekableRange, _this_currentPlaybackTimeline;
                if (!checkIsManifestLinearType(this.adPolicyConfig.sessionItem.type)) {
                    return true;
                }
                var wantsToGoToLiveEdge = false;
                if (((_this_currentPlaybackTimeline = this.currentPlaybackTimeline) === null || _this_currentPlaybackTimeline === void 0 ? void 0 : (_this_currentPlaybackTimeline_seekableRange = _this_currentPlaybackTimeline.seekableRange) === null || _this_currentPlaybackTimeline_seekableRange === void 0 ? void 0 : _this_currentPlaybackTimeline_seekableRange.end) && seekToPosition) {
                    var _this_currentPlaybackTimeline_seekableRange1, _this_currentPlaybackTimeline1;
                    var distanceToLiveEdge = ((_this_currentPlaybackTimeline1 = this.currentPlaybackTimeline) === null || _this_currentPlaybackTimeline1 === void 0 ? void 0 : (_this_currentPlaybackTimeline_seekableRange1 = _this_currentPlaybackTimeline1.seekableRange) === null || _this_currentPlaybackTimeline_seekableRange1 === void 0 ? void 0 : _this_currentPlaybackTimeline_seekableRange1.end) - seekToPosition;
                    wantsToGoToLiveEdge = distanceToLiveEdge < this.adPolicyConfig.sessionItem.liveEdgeToleranceSeconds;
                }
                return !this.currentPlaybackTimeline || Boolean(this.currentPlaybackTimeline.isAtLiveEdge) || wantsToGoToLiveEdge;
            }
        }
    ]);
    return AdPolicyManager;
}();

//# sourceMappingURL=ad-policy-manager.js.map